import React, { useRef, useState, useEffect } from "react";

import CommonDropDown from "../../Components/global-components/CommonDropDown/CommonDropDown";
import TextInput from "../../Components/global-components/CommonTextInput/TextInput";
import { FormControl, FormControlLabel, IconButton, Radio, RadioGroup, TextField } from "@mui/material"
import CommonButton from "../../Components/global-components/CommonButton/CommonButton";
import { useNavigate } from "react-router-dom";
import { showGlobalError } from "../Redux/globalErrorSlice";
import { useDispatch, useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";

import axios from "axios";
import { FaFilePdf, FaTimes } from "react-icons/fa";
import { eddUploadDocument } from "../../services/edd-file-upload-service";
import { AddCircleOutlineTwoTone } from "@mui/icons-material";

const Society_Edd = () => {
  const options = {
    industryOptions: [
      "Select",
      "Jewelry",
      "Import-Export",
      "Mining",
      "Shipping",
      "Scrap Dealing",
      "Real Estate",
      "Agriculture",
      "Stock Broking",
      "BFSI",
      "Manufacturing",
      "Other"
    ],
    option1: [
      "Select",
      "0-2.5 lacs",
      "2.5-5 lacs",
      "5-15 lacs",
      "15-20 lacs",
      "20-30 lacs",
      "30+ lacs",
    ],
    option2: [
      "Select",
      "Salaried",
      "Professional",
      "Self Employeed",
      "Student",
      "Home maker",
      "Other",
    ],
    option3: [
      "Select",
      "Government",
      "Private Limited",
      "Public Limited",
      "Trust",
      "Other",
    ],
    organisationType: [
      "Select",
      "Government",
      "Private Limited",
      "Public Limited",
      "Proprietor",
      "Partnership",
      "Trust",
      "HUF",
      "Section 25 Company",
      "Other"
    ],
    option4: ["Select", "Yes", "No", "Related to one"],
    proposerType: ["Select", "I", "C"],
    companyType: ["Select", "Private", "Public", "LLP", "Other"],
    categoryBusiness: ["Select", "Insurance", "Payments", "Lending"],
    citizenshipOption: ["Select", "Resident", "Non-Resident"],
    nationalityOption: ["Select", "Indian", "Other"],
    productTypesOption: ["Select", "Personal Loan", "Business Loan"],
    attachedFieldOptions: ["Select", "aadhaar", "drivingLicence", "passport", "voterid"]

  };

  const companyType = useSelector((state) => state.corporateSlice.companyType);
  const isExist = useSelector((state) => state.corporateSlice.isExist);
  // const kycTypeTab = useSelector((state) => state.Tabs.kycTypeTab);
  // const kycTypeTab = "Corporate";
  const Is_IDV3 = useSelector((state) => state.kycDetails.Is_IDV3);
  // const Is_IDV3 = true;


  const { reason, panTypeError } = useSelector((state) => state.ExceptionReasonSlice);
  const {
    permanentAddress,
    permanentCity,
    permanentState,
    permanentPincode,
    correspondenceAddressLineOne,
    correspondenceAddressLineTwo,
    correspondenceState,
    correspondenceCity,
    correspondencePincode,
  } = useSelector((state) => state.corporateSlice.userData);
  const kycId = useSelector((state) => state.corporateSlice.addNewKycId);
  const {
    isAryaLiteServiceUsed,
  } = useSelector((state) => state.corporateSlice.panUserdata);
  const { channelUrl, mi_u } = useSelector(
    (state) => state.partnerChannelNameSlice.marutiUserDetails
  );
  const CDDData = useSelector((state) => state.corporateSlice)

  const [isLoading, setIsLoading] = useState(false);
  // EDD Common Fields
  const [criminalProceedings, setCriminalProceedings] = useState("no");

  // Corporate Journey states
  const [catBusiness, setCatbusiness] = useState("");

  const [financialStatements, setFinancialStatements] = useState("");



  const [companyDebarred, setCompanyDebarred] = useState(false);



  // trust
  const [registrationDate, setRegistrationDate] = useState("");

  const [registrationPlace, setRegistrationPlace] = useState("");
  const [profitLossFY, setProfitLossFY] = useState([
    { Profit: "", Loss: "" },
  ]);
  const [sourceOfFund, setSourceOfFund] = useState("");

  // additional cdd fields in edd

  const [industryType, setIndustryType] = useState(CDDData.industryType);
  const [organisationType, setOrganisationType] = useState(options.organisationType.includes(companyType)? companyType : CDDData?.organisationType );
  // const [aadharNumber, setAadharNumber] = useState("");
  // const [voterIdNumber, setVoterIdNumber] = useState("");
  // const [drivingLicenceNumber, setDrivingLicenceNumber] = useState("");
  // const [passportNumber, setPassportNumber] = useState("");
  // const [existingKycNumber, setExistingKycNumber] = useState(kycId || "");
  const [political, setPolitical] = useState(CDDData.pep_flag ? "Yes" : "No");
  const [beneficialOwners, setBeneficialOwners] = useState("");
  const [beneficialOwnership, setBeneficialOwnership] = useState(CDDData.beneficialOwnership || false);
  const [beneficialOwnershipDetails, setBeneficialOwnershipDetails] = useState(CDDData.beneficialOwnershipDetails);
  const [selectedDocument, setSelectedDocument] = useState("");
  const [documentNumber, setDocumentNumber] = useState(CDDData.aadhaarNumber || CDDData.passportNumber || CDDData.drivingLicenceNumber || CDDData.voterIdNumber);
  const [aadhaarError, setAadhaarError] = useState("");
  const [errors, setErrors] = useState({
    industryType: '',
    organisationType: '',
    selectedDocument: '',
    documentNumber: "",
    existingKycNumber: '',
    pep_flag: '',
    beneficialOwnership: false,
    beneficialOwnershipDetails: '',
  });

  const [uploadedUrls, setUploadedUrls] = useState([""]);
  const inputRefs = useRef([]);
  const [fileNames, setFileNames] = useState([""]);
  const [fileUploadSuccess, setFileUploadSuccess] = useState(false)



  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (CDDData.aadhaarNumber) {
      setSelectedDocument("aadhaar")
    } else if (CDDData.passportNumber) {
      setSelectedDocument("passport")
    } else if (CDDData.drivingLicenceNumber) {
      setSelectedDocument("drivingLicence")
    } else if (CDDData.voteridNumber) {
      setSelectedDocument("voterid")
    }


  }, [CDDData])



  // handle Multiple Uploads
  const handleMultiplePdfUpload = (e) => {
    const files = Array.from(e.target.files);
    const validFiles = [];
    for (const file of files) {
      if (file.type !== "application/pdf") {
        dispatch(showGlobalError(`File "${file.name}" is not a PDF.`));
        continue;
      }
      if (file.size > 5 * 1024 * 1024) {
        dispatch(showGlobalError(`File "${file.name}" exceeds 5MB size limit.`));
        continue;
      }
      validFiles.push(file);
    }
    setFinancialStatements((prev) => [...prev, ...validFiles]);
  };

  const removeFile = (index) => {
    setFinancialStatements((prev) => prev.filter((_, i) => i !== index));
  };

  const formatFileName = (filename, maxBaseLength = 7) => {
    const dotIndex = filename.lastIndexOf(".");
    if (dotIndex === -1) return filename; // No extension
    const base = filename.slice(0, dotIndex);
    const ext = filename.slice(dotIndex); // includes the "."

    if (base.length > maxBaseLength) {
      return base.slice(0, maxBaseLength) + "..." + ext;
    }
    return filename;
  };



  const handleFileUpload = async (index, e) => {
    const file = e.target.files[0];


    if (inputRefs.current[index]) {
      inputRefs.current[index].value = "";
    }

    if (!file) return;

    if (file.type !== "application/pdf") {
      return dispatch(showGlobalError("Only PDF format is allowed."));
    }

    if (file.size > 5 * 1024 * 1024) {
      return dispatch(showGlobalError("File exceeds 5MB size limit."));
    }

    // setIncomeProof(file.name);

    if (!kycId) {
      alert("Please fill all required fields.");
      return;
    }
    const formData = new FormData();
    formData.append("income_proof", file);
    formData.append("KYC_No", kycId);

    try {
      const response = await eddUploadDocument(formData);
      if (response?.success) {
        const uploadedUrl = response?.data?.income_proof;
        const newUrls = [...uploadedUrls];
        const newNames = [...fileNames];
        newUrls[index] = uploadedUrl;
        newNames[index] = file.name;

        setUploadedUrls(newUrls);
        setFileNames(newNames);

        setFileUploadSuccess(true)
        // alert("File uploaded successfully!");
        setTimeout(() => {
          setFileUploadSuccess(false)
        }, 3000)
      } else {
        setFileUploadSuccess(false)
        dispatch(showGlobalError("Upload succeeded but no file URL returned."));
      }
    } catch (error) {
      console.error("Upload Error:", error);
      dispatch(showGlobalError("File upload failed. Check console."));
    }
  };

  const handleAdd = () => {
    if (uploadedUrls.length < 3) {
      setUploadedUrls([...uploadedUrls, ""]);
      setFileNames([...fileNames, ""]);
    }
  };

  const handleDelete = (index) => {
    // If there's only one upload block, just clear it
    if (uploadedUrls.length === 1) {
      const newUrls = [...uploadedUrls];
      const newNames = [...fileNames];
      newUrls[0] = "";
      newNames[0] = "";
      setUploadedUrls(newUrls);
      setFileNames(newNames);

      // reset file input
      if (inputRefs.current[0]) {
        inputRefs.current[0].value = "";
      }
    } else {
      // If there are multiple upload blocks, remove the entire block
      const newUrls = [...uploadedUrls];
      const newNames = [...fileNames];
      newUrls.splice(index, 1);
      newNames.splice(index, 1);
      setUploadedUrls(newUrls);
      setFileNames(newNames);

      // Update refs array
      inputRefs.current.splice(index, 1);
    }
    setFileUploadSuccess(false);
  };
  const removeUploadBlock = (index) => {
    const newUrls = [...uploadedUrls];
    const newNames = [...fileNames];
    newUrls.splice(index, 1);
    newNames.splice(index, 1);
    setUploadedUrls(newUrls);
    setFileNames(newNames);
  };

  // profit loss
  const handleAddProfitLossRow = () => {
    if (profitLossFY.length < 3) {
      setProfitLossFY([...profitLossFY, { Profit: "", Loss: "" }]);
    }
  };


  const handleChangeProfitLosss = (index, field, value) => {
    const updated = [...profitLossFY];
    updated[index][field] = value;
    setProfitLossFY(updated);
  };


  const handleRemoveProfitLossRow = (index) => {
    const updated = profitLossFY.filter((_, i) => i !== index);
    setProfitLossFY(updated);
  };

  function capitalizeFirstLetter(str) {
    if (typeof str !== 'string') {
      return str; // Return the input unchanged if it's not a string
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  let incomeFiles = {};

  const society = {
    "KYC_No": kycId,
    "Is_IDV3": Is_IDV3,
    "Registration_Date": registrationDate,
    "Registration_Place": registrationPlace,
    // "Beneficial_Owners": beneficialOwners,
    "Beneficial_Owners": beneficialOwnershipDetails,
    // "Profit_Loss_FY": profitLossFY,
    "Profit_Loss_FY":incomeFiles ,
    "Source_Of_Fund": sourceOfFund,
    "Criminal_Proceedings": criminalProceedings,
    "Company_Debarred": companyDebarred,
  }


  let old_data = JSON.stringify({
    channel: channelUrl || "",
    txnId: mi_u || "",
    kyc_id: kycId || "",
    pan_type_error: panTypeError || "",
    pan_reason: reason || "",
    permanentAddress: permanentAddress || "",
    permanentPincode: permanentPincode || "",
    permanentState: permanentState || "",
    permanentCity: permanentCity || "",
    correspondenceAddress: correspondenceAddressLineOne ? correspondenceAddressLineOne + correspondenceAddressLineTwo : permanentAddress,
    correspondenceCity: correspondenceCity || permanentCity || "",
    correspondencePincode: correspondencePincode || permanentPincode || "",
    correspondenceState: correspondenceState || permanentState || "",
    isAryaLiteServiceUsed,
    // cdd
    existingKycNumber: kycId || "",
    industryType: industryType,
    organisationType: organisationType,
    pep_flag: political === "Yes" || political === "Related to one" ? true : false,
    aadharNumber: selectedDocument === "aadhaar" ? documentNumber : "",
    passportNumber: selectedDocument === "passport" ? documentNumber : "",
    drivingLicenceNumber: selectedDocument === "drivingLicence" ? documentNumber : "",
    voterIdNumber: selectedDocument === "voterid" ? documentNumber : "",
    beneficialOwnership: beneficialOwnership,
    beneficialOwnershipDetails: beneficialOwnership ? beneficialOwnershipDetails : "",

  });
  const onClickHandler = async (e) => {
    e.preventDefault();
    let newErrors = {};
    let missingFields = [];


    // Check if ALL mandatory fields are empty (initial submit)
    // const allFieldsEmpty =
    // (isExist || !industryType ) &&
    // (isExist || !organisationType) &&
    // (isExist || !selectedDocument) &&
    // (isExist || !documentNumber) &&
    // (isExist || !political) && 
    // (isExist || (!beneficialOwnership || !beneficialOwnershipDetails));


    // if (allFieldsEmpty) {
    //   newErrors = {
    //     industryType: "Industry Type is required.",
    //     organisationType: "Organisation Type is required.",
    //     selectedDocument: "Document selection is required.",
    //     documentNumber: "Document number is required.",
    //     pep_flag: "PEP field is required.",
    //     beneficialOwnershipDetails:
    //       beneficialOwnership && !beneficialOwnershipDetails
    //         ? "Ownership details are required."
    //         : "",
    //   };


    //   // Collect field names for global popup
    //   missingFields = [
    //     "Industry Type",
    //     "Organisation Type",
    //     "Document selection",
    //     "Document number",
    //     "PEP field",
    //     "Beneficial Ownership Details",
    //   ];


    //   setErrors(newErrors);
    //   dispatch(
    //     showGlobalError(`Please fill these mandatory fields: ${missingFields.join(", ")}`)
    //   );
    //   console.log("Validation failed: All fields empty", newErrors);
    //   return;
    // }


    // INDIVIDUAL VALIDATION (one by one after first input filled)
    if (!isExist && !industryType) {
      newErrors.industryType = "Industry Type is required.";
    }

    if (!isExist && !organisationType) {
      newErrors.organisationType = "Organisation Type is required.";
    }

    if (!isExist && !selectedDocument) {
      newErrors.selectedDocument = "Document selection is required.";
    }

    if (!isExist && !documentNumber) {
      newErrors.documentNumber = "Document number is required.";
    } else {
      if(!isExist && documentNumber){
      switch (selectedDocument) {
        case "aadhaar":
          if (!/^\d+$/.test(documentNumber)) {
            newErrors.documentNumber = "Aadhaar must contain only numbers.";
          } else if (documentNumber.length !== 4) {
            newErrors.documentNumber = "Aadhaar must be exactly 4 digits.";
          }
          break;

        case "passport":
          if (!/^[A-Z]{1,2}[0-9]{2,39}$/.test(documentNumber)) {
            newErrors.documentNumber = "Invalid passport number format.";
          }
          break;

        case "voterid":
          if (documentNumber.length < 4 || documentNumber.length > 40) {
            newErrors.documentNumber =
              "Voter ID should be 4 to 40 characters.";
          }
          break;

        case "drivingLicence":
          if (!/^[A-Za-z0-9\/\-]{4,40}$/.test(documentNumber)) {
            newErrors.documentNumber = "Invalid Driving Licence format.";
          }
          break;

        default:
          if (documentNumber.length < 4 || documentNumber.length > 40) {
            newErrors.documentNumber =
              `${selectedDocument} must be 4 to 40 characters.`;
          }
          break;

      }
    }
    }


    if (!isExist && !political) {
      newErrors.pep_flag = "PEP field is required.";
    }


    if (beneficialOwnership && !beneficialOwnershipDetails) {
      newErrors.beneficialOwnershipDetails =
        "Ownership details are required when Beneficial Ownership is Yes.";
    }


    // Set Errors
    setErrors(newErrors);


    // Show First Individual Error if Any
    if (Object.keys(newErrors).length > 0) {
      const firstErrorMsg = Object.values(newErrors)[0];
      dispatch(showGlobalError(firstErrorMsg));
      return;
    }


    const finalPayload = {
      existingKycNumber: kycId || "",
      industryType,
      organisationType,
      pep_flag: political === "Yes" || political === "Related to one" ? true : false,


      // doc any one
      aadharNumber: selectedDocument === "aadhaar" ? documentNumber : null,
      passportNumber: selectedDocument === "passport" ? documentNumber : null,
      drivingLicenceNumber: selectedDocument === "drivingLicence" ? documentNumber : null,
      voterIdNumber: selectedDocument === "voterid" ? documentNumber : null,

      // beneficial
      beneficialOwnership, // boolean
      beneficialOwnershipDetails: beneficialOwnership ? beneficialOwnershipDetails : "",
    };


    try {
       uploadedUrls.forEach((url, i) => {
      if (url) incomeFiles[`income_${i + 1}`] = url;
    });
      // 1. call the existing PATCH customer-meta API
      if (!isExist) {


        const configExistingDocument = {
          method: "patch",
          url: `${process.env.REACT_APP_BASE_URL}/customer/update-customer-meta?token=${localStorage.getItem("token")}`,
          headers: {
            "Content-Type": "application/json",
          },
          data: old_data,
        };


        const oldApiResponse = await axios(configExistingDocument);
      }
      // 2. Now call the new EDD POST API
      const eddCorpConfig = {
        method: "post",
        url: `${process.env.REACT_APP_BASE_URL}/primary/edd`,
        headers: {
          "Content-Type": "application/json",
        },
        data: society,
        params: { token: localStorage.getItem("token") },
      };
      const eddResponse = await axios(eddCorpConfig);

      // 3. On full success, navigate to Success page
      navigate("/Success", {
        state: {
          kyc_ref_id: eddResponse?.data?.KYC_No,
        },
      });
    } catch (error) {
      console.error("Error in submission flow:", error);
      setIsLoading(false);
    }

  };

  return (
    <div>

      {/* Corporate Journey */}
      <>
        {/* cdd fields starts */}
        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2  gap-x-6 ">
          <div className="w-full">
            <CommonDropDown
              label="Organisation Type"
              options={options.organisationType}
              selected={organisationType}
              setSelected={setOrganisationType}
              AsteriskStar={true}

            />
          </div>
          {!isExist  && <>
          <div className="w-full ">
            <CommonDropDown
              label="Industry Type"
              options={options.industryOptions}
              selected={industryType}
              setSelected={setIndustryType}
              AsteriskStar={true}

            />
          </div>
          </>}

        </div>

        <>
          {/* <div className="md:flex block mt-4 mb-4 md:gap-[17px]"> */}
          {!isExist  && <>
          <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-x-6 mt-4 gap-y-6">
            <CommonDropDown
              label="Select Documents"
              options={options.attachedFieldOptions}
              selected={selectedDocument}
              setSelected={setSelectedDocument}
              AsteriskStar={true}
            />

            <FormControl size="small" className="w-full  flex gap-1">
              <div className="flex">
                <label className=" font-medium text-gray-900 mt-2 text-sm">
                  Document Identification Number
                  <span className="text-red-600">*</span>
                </label>
              </div>

              <TextField
                placeholder={capitalizeFirstLetter(selectedDocument) || "Enter document last 4 digit"}
                value={documentNumber}
                onChange={(e) => setDocumentNumber(e.target.value)}
                error={!!aadhaarError}
                helperText={aadhaarError}
                fullWidth
                size="small"
              />
            </FormControl>
          </div>
          </>}
        </>


        {/* <div className="w-full mt-6">
      
                          <div className="flex flex-row md:items-center justify-between gap-2">
                            <p className="text-sm font-medium text-gray-900 mb-1 w-[50%]">
                              Existing KYC Number :
                            </p>
                            <RadioGroup
                              row
                              name="existing_kyc_number"
                              value={existingKycNumber ? "yes" : "no"}
                              onChange={(e) => {
                                if (e.target.value === "no") {
                                  setExistingKycNumber("");
                                } else if (e.target.value === "yes" && !existingKycNumber) {
                                  setExistingKycNumber(" ")
                                }
                              }}
                              className="w-[45%]"
                            >
                              <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                              <FormControlLabel value="no" control={<Radio />} label="No" />
                            </RadioGroup>
                          </div>
                          {existingKycNumber && (
                            <>
                              <div className="w-full">
                                <TextInput
                                  fullWidth
                                  size="small"
                                  sx={{ marginTop: 1, marginBottom: 1 }}
                                  placeholder="Enter the Existing Kyc Number"
                                  id="existing_kyc_number"
                                  value={existingKycNumber.trim()}
                                  onChange={(e) => setExistingKycNumber(e.target.value)}
                                />
                              </div>
                            </>
                          )}
                        </div> */}



        {/* <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-x-6  mt-4"> */}

        <div className="w-full mt-6">

          <div className="flex flex-col  md:flex-row md:items-center justify-between gap-2">
            <p className="font-medium text-sm text-gray-900 mb-1 md:w-[50%]">
              Beneficial Ownership Details  :  <span className="text-red-600">*</span>
            </p>
            <RadioGroup
              row
              name="beneficial_ownership"
              value={beneficialOwnership ? "yes" : "no"}
              onChange={(e) => {
                if (e.target.value === "no") {
                  setBeneficialOwnership(false)
                } else {
                  setBeneficialOwnership(true)
                }
              }}
              className="w-[45%] "
            >

              <FormControlLabel value="yes" sx={{
                "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                {
                  color: "#E42125",
                },
                "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                  color: "#E42125",
                },
              }} control={<Radio />} label="Yes" />
              <FormControlLabel value="no" sx={{
                "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                {
                  color: "#E42125",
                },
                "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                  color: "#E42125",
                },
              }} control={<Radio />} label="No" />
            </RadioGroup>
          </div>
          {beneficialOwnership && (
            <>
              {/* <div className="w-full mt-2"> */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
                <TextInput
                  fullWidth
                  size="small"
                  sx={{ marginTop: 1, marginBottom: 1 }}
                  // label="BeneficialOwnershipDetails"
                  placeholder="Enter the Beneficial Ownership Details "
                  id="beneficial_ownership_details"
                  value={beneficialOwnershipDetails}
                  onChange={(e) => setBeneficialOwnershipDetails(e.target.value)}
                />
              </div>
            </>
          )}

        </div>



       
        {/* </div> */}


          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 ">
           
        <div className="w-full mt-1">
          <CommonDropDown
            label="Nature of Business:"
            options={options.categoryBusiness}
            selected={catBusiness}
            setSelected={setCatbusiness}
          // helperText="(Insurance / Payments / Lending)"
          />
        </div>
            <div className="w-full mt-2">
              <TextInput
                label="Source of Funds:"
                placeholder="Enter details"
                id="sourceoffund"
                value={sourceOfFund}
                onChange={(e) => setSourceOfFund(e.target.value)}
              />
            </div>
            </div>




        {/* cdd fields ends*/}
        {/* <h1>proposer type is {kycTypeTab}</h1> */}
        <div className="w-full mt-4">
          {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6 mt-4"> */}


          <div className="w-full mt-6">
            <div className="mt-5 mb-5">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-2">
                <p className="text-sm font-medium text-gray-900 mb-1 md:w-[50%]">
                  Details of criminal proceedings against the entity /
                  directors / KMPs during the last 3 Years:
                  {/* <span className="text-red-600">*</span> */}
                </p>
                <RadioGroup
                  row
                  name="key_metrics1"
                  value={criminalProceedings === "no" ? "no" : "yes"}
                  onChange={(e) =>
                    e.target.value === "no"
                      ? setCriminalProceedings("no")
                      : setCriminalProceedings("")
                  }
                  className="w-[45%]"
                >
                  <FormControlLabel
                    value="yes"
                    sx={{
                      "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                      {
                        color: "#E42125",
                      },
                      "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                        color: "#E42125",
                      },
                    }}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value="no"
                    sx={{
                      "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                      {
                        color: "#E42125",
                      },
                      "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                        color: "#E42125",
                      },
                    }}
                    control={<Radio />}
                    label="No"
                  />
                </RadioGroup>
              </div>
              {criminalProceedings !== "no" && (

                <TextInput
                  placeholder="Enter Details"
                  value={criminalProceedings}
                  onChange={(e) => setCriminalProceedings(e.target.value)}
                />
              )}
            </div>
          </div>



          <div className="w-full mt-6">
            <div className="flex flex-col  md:flex-row md:items-center justify-between gap-2">
              <p className="text-sm font-medium text-gray-900 mb-1 md:w-[50%]">
                Has the Company been debarred / blacklisted or reprimanded
                by any regulator / authority / govt. body in last 3 years:{" "}
                {/* <span className="text-red-600">*</span> */}
              </p>
              <RadioGroup
                row
                name="key_metrics3"
                value={companyDebarred ? "yes" : "no"}
                onChange={(e) => setCompanyDebarred(e.target.value === "yes")}
                className="w-[45%]"
              >
                <FormControlLabel
                  value="yes"
                  sx={{
                    "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                    {
                      color: "#E42125",
                    },
                    "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                      color: "#E42125",
                    },
                  }}
                  control={<Radio />}
                  label="Yes"
                />
                <FormControlLabel
                  value="no"
                  sx={{
                    "& .MuiSvgIcon-root:not(.MuiSvgIcon-root ~ .MuiSvgIcon-root)":
                    {
                      color: "#E42125",
                    },
                    "& .MuiSvgIcon-root + .MuiSvgIcon-root": {
                      color: "#E42125",
                    },
                  }}
                  control={<Radio />}
                  label="No"
                />
              </RadioGroup>
            </div>
          </div>


          {/* new code starts */}


        

            {/* <div className="w-full mt-4">
              <TextInput
                fullWidth
                size="small"
                // sx={{ marginTop: 1, marginBottom: 1 }} 
                // handleMargin="mt-2"
                label="Details of Beneficial Owners"
                placeholder="Enter Name"
                id="beneficial_owners"
                value={beneficialOwners}
                onChange={(e) => setBeneficialOwners(e.target.value)}
              />
            </div> */}
          {/* </div> */}


          {/* <div className="flex w-full md:w-1/3"> */}

          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6 md:mt-4">

            <TextInput
              type="date"
              label="Registraion Date:"
              placeholder="Enter details"
              id="registration_date"
              value={registrationDate}
              onChange={(e) => setRegistrationDate(e.target.value)}
            />
            <TextInput
              label="Registration Place:"
              placeholder="Enter details"
              id="registration_place"
              value={registrationPlace}
              onChange={(e) => setRegistrationPlace(e.target.value)}
            />

          </div>



          {/* <div className="w-full mt-6"> */}
          {/* <label className="block text-sm font-medium text-gray-700 mb-2">
              Profit/Loss FY:
            </label> */}
          {/* {profitLossFY.map((profitloss, index) => (
              <div
                key={index}
                className="flex flex-col md:flex-row items-start md:items-center gap-2 md:gap-4 mb-3"
              >
                <div className="flex w-full md:w-1/3">
                  <input
                    type="text"
                    placeholder="profit"
                    value={profitloss.Profit}
                    onChange={(e) => handleChangeProfitLosss(index, "Profit", e.target.value)}
                    className="border p-2 rounded w-full"
                  />
                </div>
                <div className="flex w-full md:w-1/3">
                  <input
                    type="text"
                    placeholder="loss"
                    value={profitloss.Loss}
                    onChange={(e) => handleChangeProfitLosss(index, "Loss", e.target.value)}
                    className="border p-2 rounded w-full"
                  />
                </div>
                <div className="flex gap-2">
                  {index === profitLossFY.length - 1 && profitLossFY.length < 3 && (
                    <button
                      type="button"
                      onClick={handleAddProfitLossRow}
                      className="bg-blue-500 text-white px-3 py-1 rounded"
                    >
                      +
                    </button>
                  )}
                  {profitLossFY.length > 1 && (
                    <button
                      type="button"
                      onClick={() => handleRemoveProfitLossRow(index)}
                      className="bg-red-500 text-white px-3 py-1 rounded"
                    >
                      -
                    </button>
                  )}
                </div>
              </div>
            ))} */}
          {/* </div> */}



              <div className="w-full mt-4 md:mt-4">

                    <div className="flex justify-between items-start mb-1">

                      <div className="flex flex-col">

                        <label className="font-medium text-sm">

                         Profit / Loss in last 3 FYs (upload last 3 FYs audited financial statements)

                        </label>

                        <div className="text-xs text-[#5A5A5A] mt-1">

                          Allowed file size is 5 MB · Supported format: PDF

                        </div>

                      </div>

                    </div>



                    {/* File attachments container */}

                    <div className="flex flex-wrap gap-3 mb-3">

                      {uploadedUrls.map((url, index) => (

                        <div

                          key={index}

                          className="w-full md:w-[calc(33.333%-0.75rem)] transition-all duration-300"

                        >

                          {url ? (

                            // Uploaded file display

                            <div className="border flex justify-center py-2 border-green-200 bg-green-50 rounded-lg relative h-full">

                              <div className="flex items-center justify-center gap-2">

                                <div className="flex-shrink-0 text-red-600">

                                  <FaFilePdf size="16" />

                                </div>

                                <div className="min-w-0 flex-1">

                                  <p className="text-green-800 text-sm font-medium truncate">

                                    {fileNames[index] || `Document ${index + 1}`}

                                  </p>

                                </div>

                                {/* Show delete icon */}

                                <IconButton

                                  onClick={() => handleDelete(index)}

                                  color="error"

                                  size="small"

                                  className="flex-shrink-0 hover:bg-gray-50"

                                >

                                  <DeleteIcon fontSize="small" />

                                </IconButton>

                              </div>

                            </div>

                          ) : (

                            // Empty file input box

                            <div

                              className={`border-2 border-dashed rounded-lg p-2 transition-all duration-300 relative cursor-pointer border-gray-300 hover:border-gray-400`}

                              onClick={() => inputRefs.current[index]?.click()}

                            >

                              {/* Show delete (cross) icon for all except first box */}

                              {uploadedUrls.length > 1 && (

                                <IconButton

                                  onClick={(e) => {

                                    e.stopPropagation();

                                    handleDelete(index);

                                  }}

                                  color="error"

                                  size="small"

                                  className="absolute -top-2 -right-2 float-right hover:bg-gray-50 z-10 bg-white"

                                >

                                  <FaTimes size={14} />

                                </IconButton>

                              )}



                              <div className="flex items-center justify-center gap-2">

                                <div className="p-2 rounded-full bg-gray-100 text-gray-500">

                                  <FaFilePdf size={16} />

                                </div>

                                <div className="text-center">

                                  <p className="text-xs text-gray-500 mt-1">Click to upload</p>

                                </div>

                              </div>



                              <input

                                id={`pdf-upload-${index}`}

                                type="file"

                                accept="application/pdf"

                                hidden

                                ref={(ref) => (inputRefs.current[index] = ref)}

                                onChange={(e) => handleFileUpload(index, e)}

                              />

                            </div>

                          )}

                        </div>

                      ))}



                      {/* Automatically add next empty upload field after successful upload */}

                      {uploadedUrls.filter((url) => url).length === uploadedUrls.length &&

                        uploadedUrls.length < 3 && (

                          <div className="w-full md:w-[calc(33.333%-0.75rem)]">

                            <div

                              className="border-2 border-dashed rounded-lg p-2 transition-all duration-300 relative cursor-pointer border-gray-300 hover:border-gray-400"

                              onClick={() => inputRefs.current[uploadedUrls.length]?.click()}

                            >

                              <div className="flex items-center justify-center gap-2">

                                <div className="p-2 rounded-full bg-gray-100 text-gray-500">

                                  <FaFilePdf size={16} />

                                </div>

                                <div className="text-center">

                                  <p className="text-xs text-gray-500 mt-1">Click to upload</p>

                                </div>

                              </div>



                              <input

                                id={`pdf-upload-${uploadedUrls.length}`}

                                type="file"

                                accept="application/pdf"

                                hidden

                                ref={(ref) => (inputRefs.current[uploadedUrls.length] = ref)}

                                onChange={(e) => handleFileUpload(uploadedUrls.length, e)}

                              />

                            </div>

                          </div>

                        )}

                    </div>



                    {/* Success message */}

                    <div className="mt-2">

                      <p className="text-green-600 text-sm font-medium">

                        {fileUploadSuccess && "File uploaded successfully!"}

                      </p>

                    </div>

                  </div>



          {!isExist  && <>
          <div className="w-full mt-4">
            <CommonDropDown
              options={options.option4}
              selected={political}
              setSelected={setPolitical}
              label={"Are you a Politically Exposed Person(PEP) or family member/ close relative / associate of PEP"}
              AsteriskStar={true}
              labelSize="small"


            />
            {/* <p className="text-red-500 text-sm" id="incomeError">
                                                    {error && error}
                                                  </p> */}
            <i className="text-[10px] font-medium text-black">
              "Politically Exposed Persons" (PEPs) are individuals who have been entrusted with prominent public functions by a foreign country, including the heads of States or Governments, senior politicians, senior government or judicial or military officers, senior executives of state-owned corporations and important political party officials.
            </i>

          </div>
          </>}

          {/* new code ends */}
        </div>



        <div className="w-full mt-7 md:w-[15%] mb-3 flex justify-center">
          <CommonButton
            center
            label="Submit"
            filled
            onClickHandler={onClickHandler}
          />
        </div>
      </>

    </div >
  );
};
export default Society_Edd;